// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"8280":"f943827f","8680":"fe581f21"}[chunkId] + ".css";
};